import getIn from 'transmute/getIn';
export const getIndexedAsyncGenericChannels = getIn(['genericChannels']);